import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Card } from '../../../../design-system';

type EmailCardProps = {
  email: string;
};

const EmailCard: React.FC<EmailCardProps> = (props: EmailCardProps) => {
  const { email } = props;
  return (
    <Card title="Email">
      <Box p={2} pt={0}>
        <Typography paragraph>
          Your current email address is <strong>{email}</strong>
        </Typography>
        <Tooltip title="Please contact us to change your email address">
          <span>
            <Button variant="outlined" size="small" disabled>
              Change email
            </Button>
          </span>
        </Tooltip>
      </Box>
    </Card>
  );
};

export default EmailCard;
